import { MediaContentShowcaseItem } from "@onnit-js/ui/components/module/MediaContentShowcase";

const ingredients: MediaContentShowcaseItem[] = [
    {
        image: `citicoline.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: "Cognizin® Citicoline",
        summary: "A naturally-occurring brain chemical.",
        detail:
            'Helps maintain levels of other chemicals that transport messages in the brain, supporting attention and focus.<span class="oui-sup">&dagger;</span>',
    },
    {
        image: `huperzia-serrata.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: "Huperzia Serrata",
        summary: "A clubmoss that contains the compound Huperzine A.",
        detail:
            "Helps stop the breakdown of acetylcholine, a neurotransmitter.<span class=\"oui-sup\">&dagger;</span>",
    },
    {
        image: `caffeine.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: "Caffeine Anhydrous",
        summary: "A concentrated form of the stimulant that made coffee famous.",
        detail:
            'Shown to support mood, attention, and cognitive performance.<span class="oui-sup">&dagger;</span> Alpha BRAIN<span class="oui-sup">&reg;</span> Black Label supplies only a small dose of caffeine, with the goal of aiding mental acuity without promoting jitters.',
    },
    {
        image: `l-theanine.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: "L-Theanine",
        summary: "An amino acid.",
        detail: 'When combined with caffeine, L-Theanine has been shown to promote a state of relaxed alertness—where you’re awake but not overstimulated.<span class="oui-sup">&dagger;</span>',
    },
    {
        image: `phosphatidylserine.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: "Phosphatidylserine",
        summary: "A type of fat found in cell membranes.",
        detail:
            'Plays a key role in the maintenance of cellular function, especially in the brain.<span class="oui-sup">&dagger;</span>',
    },
    {
        image: `lutemax.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: "Lutemax 2020®",
        summary: "An extract from the marigold flower containing the plant carotenoids lutein and zeaxanthin.",
        detail:
            'Found to support eye function on visual performance tests.<span class="oui-sup">&dagger;</span> Additionally, lutein and zeaxanthin have been shown to aid both the brain and the eyes.<span class="oui-sup">&dagger;</span>',
    },
    {
        image: `mucuna-pruriens.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: "Mucuna Pruriens",
        summary: "A tropical bean that contains L-Dopa, an amino acid that supports dopamine levels.",
        detail:
            'Mucuna pruriens has been shown to help protect brain function.<span class="oui-sup">&dagger;</span>',
    },
];

export default ingredients;
